/**
 * The case-draft (create/edit) flow only supports specific type/version combos.
 *
 * Cushing has two form generations. v2 is the current one and is reachable both
 * for creating and editing. The legacy v1 form is version-less on the backend and
 * still editable, but no new v1 cases are created — so version-less cushing is
 * allowed only when editing an existing draft (an `id` is present). Any other
 * version segment ('v1', 'v3', junk) only ever comes from a hand-crafted URL and
 * points at a route that does not exist, so it must be blocked. Acromegaly has a
 * single, version-less form (create and edit), so it must not carry a version.
 * See RR-606.
 *
 * Note: this guards the draft flow only. Viewing existing published cushing v1
 * cases stays available through the (version-less) CaseView route.
 */
export const isDraftAllowed = (type?: string, version?: string, id?: string): boolean => {
  switch (type) {
    case 'cushing':
      return version === 'v2' || (version === undefined && Boolean(id));
    case 'acromegaly':
      return !version;
    default:
      return false;
  }
};
